module.exports = __webpack_public_path__ + "img/delete.bb3f6891.svg";